import { Component } from "@angular/core";
import { LegalPageComponent } from "../legal-page/legal-page.component";
import { TERMS_AND_CONDITIONS } from "../data/terms-and-conditions.data";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-terms-conditions",
  imports: [LegalPageComponent],
  templateUrl: "./terms-conditions.component.html",
})
export class TermsConditionsComponent {
  sections = TERMS_AND_CONDITIONS;
  appName = environment.appName

  introKey = `<p class="mb-2">ยินดีต้อนรับสู่ <span class="text-primary fw-bold">${this.appName || 'Wise'}</span>
                    ซึ่งให้บริการคอร์สเรียนออนไลน์แก่ผู้ใช้งาน
                    การสมัครสมาชิก การสั่งซื้อคอร์ส หรือการใช้งานเว็บไซต์ ถือว่าผู้ใช้งานได้อ่าน เข้าใจ
                    และยอมรับข้อตกลงและเงื่อนไขฉบับนี้แล้ว</p>`
}
